import { useState } from 'react';
import { faqData } from '@/mocks';

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="container-custom max-w-3xl">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于51吃瓜网站的常见疑问解答
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className={`rounded-xl border transition-all ${
                openId === faq.id
                  ? 'bg-background-50 border-primary-200'
                  : 'bg-background-50 border-background-200 hover:border-background-300'
              }`}
            >
              <button
                type="button"
                className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left"
                onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
              >
                <span className="text-sm md:text-base font-medium text-foreground-800">
                  {faq.question}
                </span>
                <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full text-xs transition-colors ${
                  openId === faq.id
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className={openId === faq.id ? 'ri-subtract-line' : 'ri-add-line'} />
                </span>
              </button>
              {openId === faq.id && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}